import { render, staticRenderFns } from "./CreateEditCommands.vue?vue&type=template&id=3f31d373&scoped=true&"
import script from "./CreateEditCommands.vue?vue&type=script&lang=js&"
export * from "./CreateEditCommands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31d373",
  null
  
)

export default component.exports